<script>
  import MemoryDetailView from "./MediaDisplay/MemoryDetailView.svelte"
  import {modalStatus} from "./Stores";
  import Carousel from "svelte-carousel";
  import {currentMemory} from "./Stores";

</script>

<main>
<!--  <petInfo>-->
<!--    <p>Do we want to do anything with this header space in detail view?</p>-->
<!--  </petInfo>-->

  <dismiss>
    <button on:click="{() => {
    $modalStatus = 'off'
    $currentMemory = null
    }
   }">Dismiss</button>
  </dismiss>

  {#if $currentMemory !=null}
    <memory>
      <Carousel infinite={false} dots={true} swiping={false}>
        <MemoryDetailView memory='{$currentMemory}'/>
      </Carousel>
    </memory>
  {/if}
</main>

<style>
  main {
    display: grid;
    grid-template-columns: 1fr 200px;
    grid-template-rows: 100px 1fr;
    grid-template-areas:
    "petInfo dismiss"
    "memory memory"
    ;

    height: 100%;
    width: 100%;
    justify-items: stretch;
    align-items: stretch;
  }

  petInfo {
    grid-area: petInfo;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding-left: 35px;
  }

  avatarIcon {
    margin-right: 20px;
  }

  dismiss {
    grid-area: dismiss;
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    padding-right: 20px;

  }

  memory {
    grid-area: memory;
  }

  p {
    color: white;
  }
</style>